import { useStore } from "../../../stores/StoreContext";

export const useIsChatDisabled = (): boolean => {
  const { budgetStore } = useStore();

  return budgetStore.hasBudget === false;
};
